var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2015 9.07368C10.0713 9.20386 9.86026 9.20386 9.73009 9.07368L8.33318 7.67678V10.8679C8.33318 11.052 8.18394 11.2013 7.99985 11.2013C7.81575 11.2013 7.66651 11.052 7.66651 10.8679V7.66847L6.26545 9.06954C6.13527 9.19971 5.92422 9.19971 5.79404 9.06954C5.66387 8.93936 5.66387 8.72831 5.79404 8.59813L7.99569 6.39648L8.20233 6.60312C8.22575 6.62105 8.24672 6.64203 8.26466 6.66545L10.2015 8.60228C10.3317 8.73245 10.3317 8.94351 10.2015 9.07368Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 12.5124C5.14908 12.5124 4.99984 12.6616 4.99984 12.8457C4.99984 13.0298 5.14908 13.179 5.33317 13.179H10.6665C10.8506 13.179 10.9998 13.0298 10.9998 12.8457C10.9998 12.6616 10.8506 12.5124 10.6665 12.5124H5.33317Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6665 1.66667C1.6665 0.746192 2.4127 0 3.33317 0H9.6421L14.3332 4.52714V14.3333C14.3332 15.2538 13.587 16 12.6665 16H3.33317C2.4127 16 1.6665 15.2538 1.6665 14.3333V1.66667ZM3.33317 0.666667C2.78089 0.666667 2.33317 1.11438 2.33317 1.66667V14.3333C2.33317 14.8856 2.78089 15.3333 3.33317 15.3333H12.6665C13.2188 15.3333 13.6665 14.8856 13.6665 14.3333V5.33333H8.99984V0.666667H3.33317ZM9.6665 0.950031V4.66667H13.5177L9.6665 0.950031Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadOutline);
export default __webpack_public_path__ + "static/media/upload-outline.917b28a51fabf8b21ee213ca667133f7.svg";
export { ForwardRef as ReactComponent };